import { writable } from "svelte/store";

const resultsMessage = writable("");

const resultsMessageStore = {
  subscribe: resultsMessage.subscribe,
  set: resultsMessage.set,
  clear: () => {
    resultsMessage.set("");
  },
};
export default resultsMessageStore;
